export default __webpack_public_path__ + "static/media/element_15.12b4a20f.avif";